<div class="upload_img">
   
  <div class="d__flex just-s header__">
    <h5 class="header m-0">Attach Images</h5>
    <ion-icon (click)="modalCtrl.dismiss()" name="close-outline"></ion-icon>
  </div>

  <div class="drop_down">
    <select class="form-input form-select" interface="popover" (change)="value_changed($event,product_info)" [(ngModel)]="selected_attr_id" [value]="selected_attr_id" >
      <option *ngFor="let c of product_info.product_attributes" value="{{c.product_attribute}}">{{c.attribute}}</option>
    </select>
  </div>

  <p *ngIf="alert" class="error m-0">{{alert_msg}}</p>




  <div *ngIf="product_info.selected_attr" class="accordion__">
    <ion-accordion-group>
      <ion-accordion  *ngFor="let c of product_info.selected_attr.options;let i = index" [value]="i">
        <ion-item slot="header" lines="none" color="light">
          <ion-label>{{c.option_value}}</ion-label>
        </ion-item>
        <div class="ion-padding images__div d__flex" slot="content">
          <div class="image d__flex mouse just-c" *ngFor="let item of c.image_list;let j = index" (click)="item.check =! item.check">
            <ion-icon *ngIf="item.check" class="icon" src="assets/icon/image_check.svg" ></ion-icon>
            <img *ngIf="item.detail_thumbnail else file_data" [src]="db.product_img(item.detail_thumbnail)">
            <ng-template #file_data>
              <img [src]="item.filedata">
            </ng-template>
          </div>
        </div>
      </ion-accordion>
    </ion-accordion-group>
  </div>

  <div class="d__flex buttons__">
    <ion-button (click)="save_data(product_info)" class="save_b" fill="clear">Save</ion-button>
  </div>
  
</div>  